import useRequest from '@/websdk/utils/request';
import { useEffect } from 'react';

export default (function (params) {
  const { isRequestSuccessed, data, isLoading, exec } = useRequest({
    url: ``,
    name: 'SHUTDOWN_REASON_RECORD_GetMain',
    method: 'GET',
  });

  useEffect(() => {
    if (params) {
      let url = `/api/shutdown/reason/record/main`;
      Object.keys(params).forEach((key, index) => {
        if (index === 0) {
          url += '?';
        } else {
          url += '&';
        }
        url += `${key}=${params[key]}`;
      });
      exec(url);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);
  return [isRequestSuccessed, data === undefined ? [] : data || [], exec, isLoading];
});
